import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

const Container = styled.div`
  background-color: ${props => props.color};
  border: 0;
  height: 10px;
  margin: 0;
  border-radius: 5px;
  width: ${props => props.width};
  align-self: ${props => props.align};
  transform: translateY(50%) ;
  ${({ top }) => top && `
    transform: translateY(-50%) ;
  `}
  
  @media (max-width: 919px){
    align-self: center;
  }
  
`
const Line = ({ width, align, color, top }) => (
  <Container width={width} align={align} color={color} top={top} />
)


Line.propTypes = {
  width: PropTypes.string,
  align: PropTypes.string,
  color: PropTypes.string,
  top: PropTypes.bool
}
Line.defaultProps = {
  width: '64px',
  align: 'center',
  color: 'var(--cThird)',
  top: false
}
export default Line
